<template>
<loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll 
          :title="$t('settings.backup')" 
          target="/Settings" 
          :hassubline="!isShrunk"
          :hasmenu="false"
          :isShrunk="isShrunk"
          >
            <template #icon>
              <IconBackup             
                class="transition-all duration-300"
                :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
            </template>
            <template #subline>
              {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
            </template>
      </HeadlineSubScroll>


    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody v-if="logbox">
      <template v-slot:formgrid>
        <div class="form-group mb-2">
          <SelectWithLabelIcon
              v-model="backuptype"
              :label="$t('setbackup.backupfor')"
          >
            <template v-slot:options>
              <option value='all'>
                {{ $t('setbackup.all') }}
              </option>
              <option value='settings'>
                {{ $t('setbackup.settings') }}
              </option>
              <option value='token'>
                {{ $t('setbackup.token') }}
              </option>
              <option value='statistic'>
                {{ $t('setbackup.statistic') }}
              </option>
            </template>
          </SelectWithLabelIcon>
        </div>
        <div class="form-group mt-7 mb-2">
          <ActionButton 
              @click="createbackup();"
              >
              {{ $t('setbackup.create') }}
          </ActionButton>
        </div>
        <div class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setbackup.available', {count: allbackupList.length}, allbackupList.length ) }}</div>           
        </div>

        <div class="form-group mb-2 sm:col-span-2">

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div v-for="(group, index) in backupGroups" :key="index" class="space-y-2">
              <h3 class="font-semibold text-lg mb-2">{{ group.label }}</h3>
              <div v-for="(backup, bIndex) in group.data" :key="bIndex">
                <div 
                  @click="selectBackup(backup)"
                  :class="backup.select ? 'bg-green-100' : 'bg-slate-100 hover:bg-slate-200'"
                  class="px-2 py-1 rounded cursor-pointer"
                  >
                      <IconSave v-if="!backup.select" class="inline-block mr-1 w-6 h-6" />
                      <IconCheck v-if="backup.select" class="inline-block mr-1 w-6 h-6" />
                      {{ $t('setbackup.backupfrom', {date: $dayjs(backup.creation).format('DD.MM.YYYY - HH:mm:ss')} ) }}
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="form-group mb-2 sm:col-span-2">
          <ActionButton 
              @click="loadbackup();"
              :disabled="!isBackupSelected"
              >
              Backup laden
          </ActionButton>
        </div>

        <div class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">Backup Konfiguration</div>           
        </div>
        <div class="form-group mt-4 mb-2 space-y-4 sm:col-span-2">
            <ToggleWithLabel 
              v-model="autosettings"
              label="Auto-Backup für Einstellungen"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
            />
            <ToggleWithLabel 
              v-model="autotoken"
              label="Auto-Backup für RFIDs"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
            />
            <ToggleWithLabel 
              v-model="autostatistic"
              label="Auto-Backup für Ladevorgänge"
              :ontext="$t('common.yes')"
              :offtext="$t('common.no')"
            />            
        </div>
        
        <div class="form-group mb-2">
          <SelectWithLabelIcon
              v-model="usbselect"
              label="USB verwenden für Backup"
          >
            <template v-slot:options>
              <option value='0'>
                Nein
              </option>
              <option value='1'>
                Wenn möglich
              </option>
            </template>
          </SelectWithLabelIcon>
        </div>
        <div class="form-group mt-7 mb-2">
          <ActionButton 
              @click="save_config();"
              :disabled="usbselect==backupconfig.useUSB"
              >
              {{ $t('common.save') }}
          </ActionButton>
        </div>

      </template>
    </SettingsBody>
    <SettingsBody v-else>
      <template v-slot:formgrid>
        <div class="w-full mt-4 sm:col-span-2">
          <TextfieldWithLabel
              :text="$t('setreports.onlylogbox',{box: this.$store.state.WbName })"
            />  
          </div>
      </template>
    </SettingsBody>
</SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconBackup from './icons/IconBackup.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import IconCheck from './icons/IconCheck.vue'
import IconSave from './icons/IconSave.vue'
//import IconSpinner from './icons/IconSpinner.vue'
export default {
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconBackup,
    SettingsHeader, SettingsBody, ActionButton, ToggleWithLabel, SelectWithLabelIcon, TextfieldWithLabel,
    IconCheck, IconSave
  },  
  data() {
    return {
          isLoading: false,
          isBackupLoad: false,
          usbselect: 0,
          backuptype: 'all',
          errorMessage: 'all',
          backupconfig: [],
          backupsettings: [],
          backuptoken: [],
          backupstatistic: [],
          autosettings: false,
          autotoken: false,
          autostatistic: false,
          loadBackupType: '',
          loadBackupUrl: '',
          isShrunk: false,
    }
  },
  computed: {
    logbox() {
      if(this.$store.state.WbId==this.$store.state.WbLogId)
        return true;
      else
        return false;
    },
    backupGroups() {
      return [
        { label: this.$t('setbackup.settings'), count: this.backupconfig.noSettings, data: this.backupsettings },
        { label: this.$t('setbackup.token'), count: this.backupconfig.noToken, data: this.backuptoken },
        { label: this.$t('setbackup.statistic'), count: this.backupconfig.noStatistic, data: this.backupstatistic },
      ];
    },
    allbackupList() {
      return [
        ...this.backupsettings,
        ...this.backuptoken,
        ...this.backupstatistic
      ];
    },
    isBackupSelected(){
        const all = [
        ...this.backupsettings,
        ...this.backuptoken,
        ...this.backupstatistic
      ];
      return all.some(b => b.select);
    }
  },
  methods: {   
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    selectBackup(selected) {
      // Alles deselektieren
      const allBackups = [
        ...this.backupsettings,
        ...this.backuptoken,
        ...this.backupstatistic
      ];
      if (selected.select) {
        // Wenn bereits selektiert → deselektieren
        selected.select = false;
        this.loadBackupType = '';
        this.loadbackupurl = '';
      } else {
        // Erst alles zurücksetzen
        allBackups.forEach(b => (b.select = false));

        // Neues Backup auswählen
        selected.select = true;
        this.loadBackupType = selected.typ;
        this.loadbackupurl = selected.url;
      }
    },
    async createbackup() {
      this.isLoading = true;
      this.errorMessage = ''; // clear previous error

      const types = this.backuptype === 'all'
        ? ['settings', 'token', 'statistic']
        : [this.backuptype];

      try {
        for (const type of types) {
          const response = await this.axios.get(
            `wallbox/update.php?action=write_backup&user=${this.$store.state.token}&typ=${type}`
          );

          const data = response.data;
          console.log(`Backup response for type "${type}":`, data);

          if (data.status === 'token') {
            this.$router.push({ path: '/' });
            return;
          }

          if (data.status !== 'ok') {
            this.errorMessage = `Backup failed for type "${type}".`;
            console.error(`Error creating backup for type "${type}"`);
            return;
          }
        }

        // Optional: success message
        // this.successMessage = 'Backup completed successfully.';

      } catch (error) {
        this.errorMessage = 'No connection to wallbox.';
        console.error('Error during backup:', error);
      } finally {
        this.isLoading = false;
        this.loaddata();
      }
    },
    convertToLocal(dateTimeString) {
        // Falls der Eingabestring leer ist, direkt zurückgeben
        if (!dateTimeString) return "";

        try {
            // Erstellen eines UTC-Datumsobjekts
            let utcDate = new Date(dateTimeString.replace(" ", "T") + "Z");

            // Falls das Datum ungültig ist, leeren String zurückgeben
            if (isNaN(utcDate.getTime())) return "";

            // Datum in lokaler Zeit formatieren
            let year = utcDate.getFullYear();
            let month = String(utcDate.getMonth() + 1).padStart(2, "0"); // Monat ist 0-basiert
            let day = String(utcDate.getDate()).padStart(2, "0");
            let hours = String(utcDate.getHours()).padStart(2, "0");
            let minutes = String(utcDate.getMinutes()).padStart(2, "0");
            let seconds = String(utcDate.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return ""; // Fehlerfall absichern
        }
    },
    async loaddata() {
      this.isLoading = true;
      const token = this.$store.state.token;

      const BackupConfigUrl = `wallbox/info.php?action=get_backup_config&user=${token}`;
      const BackupSettingsUrl = `wallbox/update.php?action=search_backup&user=${token}&typ=settings`;
      const BackupTokenUrl = `wallbox/update.php?action=search_backup&user=${token}&typ=token`;
      const BackupStatisticUrl = `wallbox/update.php?action=search_backup&user=${token}&typ=statistic`;

      try {
        const [
          resConfig,
          resSettings,
          resToken,
          resStatistic
        ] = await Promise.all([
          this.axios.get(BackupConfigUrl),
          this.axios.get(BackupSettingsUrl),
          this.axios.get(BackupTokenUrl),
          this.axios.get(BackupStatisticUrl)
        ]);

        // Handle Config
        if (resConfig.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        } else if (resConfig.data.status === 'ok') {
          this.backupconfig = resConfig.data.tbl_backup || {};
          this.usbselect = this.backupconfig.useUSB;
          this.autosettings = this.backupconfig.enableSettings === 1;
          this.autotoken = this.backupconfig.enableToken === 1;
          this.autostatistic = this.backupconfig.enableStatistic === 1;
        } else {
          console.warn('Error retrieving backup config');
        }

        // Handle Settings
        if (resSettings.data.status === 'ok') {
          this.backupsettings = resSettings.data.backup.map(set => ({
                  ...set,
                  select: false,
                  creation: this.convertToLocal(set.creation),
              })) || {};
        } else {
          console.warn('Error retrieving backup settings');
        }

        // Handle Token
        if (resToken.data.status === 'ok') {
          this.backuptoken = resToken.data.backup.map(set => ({
                  ...set,
                  select: false,
                  creation: this.convertToLocal(set.creation),
              })) || {};
        } else {
          console.warn('Error retrieving backup token');
        }

        // Handle Statistics
        if (resStatistic.data.status === 'ok') {
          this.backupstatistic = resStatistic.data.backup.map(set => ({
                  ...set,
                  select: false,
                  creation: this.convertToLocal(set.creation),
              })) || {};
        } else {
          console.warn('Error retrieving backup statistics');
        }

      } catch (error) {
        console.error('Error fetching backup data:', error);
      } finally {
        this.isLoading = false;
      }
    }
  },
  created() {
    this.loaddata();
  },
};
</script>

<style scoped>
</style>
